import CustomerService from '@/services/customers-service';
import _ from 'lodash';
import CustomerOptions from '@/mixins/customers/customer-options';
import { GET_CUSTOMER_OPTION_NAME } from '@/sections/options/options-mutation-type';
import pageKeyNames from '@/utils/page-key-names';

export default {
	mixins: [CustomerOptions],
	computed: {
		hasReadPermission() {
			return this.validatePermission('forms.read');
		},
		currentCustomerName() {
			return this[GET_CUSTOMER_OPTION_NAME](
				this.$route.params.customerId
			);
		},
		displayNav() {
			const path = _.get(this, '$route.path', '');
			return _.startsWith(path, `/clients`) && path.includes('/forms');
		},
		customerData() {
			const user = this.$store.getters['oidcStore/oidcUser'];
			return {
				customerId: this.$route.params.customerId,
				userId: user.sub,
				email: user.Email
			};
		},
		actions() {
			return [
				{
					id: 1,
					action: this.vueLoginByPass,
					disabled: false,
					iconClass: 'icon icon-vue',
					label: 'VUE',
					title: 'Select to go to the home page',
					type: 'anchor',
					visible: false //TODO: remember go back to true
				},
				{
					id: 2,
					action: '#',
					disabled: true,
					iconClass: 'icon icon-error',
					label: 'Error Log',
					title: 'Select to go to the error log page',
					type: 'route-link',
					visible: true
				},
				{
					id: 3,
					action: '#',
					disabled: true,
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to the transactions page',
					type: 'route-link',
					visible: true
				},
				{
					id: 4,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: '',
					title: 'select to see the more actions',
					type: 'dropdown',
					visible: this.hasReadPermission,
					items: [
						{
							id: 5,
							action: {
								path: `/clients/${this.customerData.customerId}/forms`
							},
							page: pageKeyNames.FORM,
							disabled: false,
							iconClass: 'icon icon-document',
							label: 'Forms',
							title: 'Select to go to the form page',
							type: 'route-link',
							visible: this.hasReadPermission
						}
					]
				}
			];
		}
	},
	methods: {
		async vueLoginByPass(e) {
			e.preventDefault();
			const self = this;
			await CustomerService.VueLoginBypass(self.customerData)
				.then(response =>
					response && response.bypassUrl
						? window.open(response.bypassUrl, '_blank')
						: null
				)
				.catch(error => {
					let status = 0;
					error ? (status = 400) : status;
					self.updateToast({ status: status, message: error });
				});
		},
		updateToast(val) {
			this.$store.dispatch('toastMessages/show', {
				toastId: 'clients.action',
				statusCode: val.status,
				message: val.message,
				slot: 'default',
				useIcon: true,
				userDismissable: true
			});
		}
	}
};
